export default defineNuxtRouteMiddleware((to, _from) => {
  /**
     * specific rule for backend that redirects to /r/blog/**
     * it should leads to Nuxt 404 page instead of trying to fetch data
     */
  if (/^\/r\/blog.*/.test(to.path)) {
    return abortNavigation({ statusCode: 404, statusMessage: 'Not Found' })
  }
})
